import onPause from "./on-property-percents/on-pause";
/**
 *
 * @param {TriggerProps} trigger
 * @param {TimelineMapProps} timeline
 * @param {Boolean} enter
 * @param {Number} now
 * @returns {Number}
 */
const getOffsetStartTime = (trigger, timeline, enter, now) => {
  const type = enter ? "enter-time" : "leave-time";
  const time = /** @type {Number} */ (timeline.get(type));

  let startTime = time;

  if (!time) {
    const switched = /** @type {Boolean} */ (trigger.get("mode-switch"));
    const delay = /** @type {Number} */ (timeline.get("o_delay")) || 0;

    startTime = now + (switched ? delay : 0);

    timeline.set(type, startTime);

    startTime = now;
  }

  return startTime;
};

export default getOffsetStartTime;
